(() => {
  const root = (() => {
    const value = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    return value.endsWith('/') ? value : value + '/';
  })();

  async function syncCartBadge() {
    try {
      const response = await fetch(root + 'cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
        cache: 'no-store'
      });
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll('.pana2-cart span').forEach((badge) => {
        badge.textContent = String(cart.item_count || 0);
      });
    } catch (_) {}
  }

  window.addEventListener('pageshow', syncCartBadge);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) syncCartBadge();
  });
})();
